import React from "react";
import ContentEditable from "react-contenteditable";
import "../../../../components/themes/feedmeonline.css";

const Cta4 = (props) => {
  const { brandGuidelines } = props;

  const handleChangeFunction = (element, event) => {
    const { blockKey, onContentChange } = props;
    if (event.target.value !== undefined) {
      onContentChange(blockKey, element, event.target.value);
    }
  };

  const {
    backgroundColor,
    ctaUrl1,
    ctaButtonColor,
    ctaButtonText,
    topSpacer,
    bottomSpacer,
    blockKey,
  } = props;

  return (
    <table
      key={blockKey}
      border="0"
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      role="presentation"
    >
      <tbody>
        <tr>
          <td
            bgcolor={backgroundColor}
            style={{
              backgroundColor: backgroundColor,
              padding: `${topSpacer}px 20px ${bottomSpacer}px 20px`,
            }}
            valign="top"
            align="center"
          >
            <table
              border="0"
              cellPadding="0"
              cellSpacing="0"
              role="presentation"
            >
              <tbody>
                <tr>
                  <td
                    bgcolor={ctaButtonColor}
                    style={{
                      backgroundColor: ctaButtonColor,
                      padding: "15px 17px",
                      borderRadius: "6px",
                    }}
                    valign="top"
                    align="center"
                  >
                    <a
                      href={ctaUrl1}
                      style={{
                        color: "#ffffff",
                        fontFamily: brandGuidelines.fontStack.primary,
                        fontSize: brandGuidelines.buttonMedium.size,
                        fontWeight: brandGuidelines.buttonMedium.fontWeight,
                        lineHeight: "1.5",
                        textDecoration: "none",
                        wordBreak: "break-word",
                        display: "block",
                      }}
                      onClick={(e) => e.preventDefault()}
                    >
                      <ContentEditable
                        tagName="span"
                        html={ctaButtonText}
                        disabled={false}
                        onChange={(event) => {
                          handleChangeFunction("ctaButtonText", event);
                        }}
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Cta4;
